import { ProductScreenshot } from 'components/ProductScreenshot';
import CreateNewActionLight from "../../../../contents/docs/getting-started/images/create-new-action-light-mode.png";
import CreateNewActionDark from "../../../../contents/docs/getting-started/images/create-new-action-dark-mode.png";
import NamingTheActionLight from "../../../../contents/docs/getting-started/images/naming-the-action-light-mode.png";
import NamingTheActionDark from "../../../../contents/docs/getting-started/images/naming-the-action-dark-mode.png";
import MatchGroupDark from "../../../../contents/docs/getting-started/images/match-group-dark-mode.png";
import MatchGroupLight from "../../../../contents/docs/getting-started/images/match-group-light-mode.png";
import NewInsightDark from "../../../../contents/docs/getting-started/images/new-insight-dark-mode.png";
import NewInsightLight from "../../../../contents/docs/getting-started/images/new-insight-light-mode.png";
import FilterReferrerAndBreakdownDark from "../../../../contents/docs/getting-started/images/filter-referrer-and-breakdown-dark-mode.png";
import FilterReferrerAndBreakdownLight from "../../../../contents/docs/getting-started/images/filter-referrer-and-breakdown-light-mode.png";
import BrokenDownTrendBarDark from "../../../../contents/docs/getting-started/images/broken-down-trend-bar-dark-mode.png";
import BrokenDownTrendBarLight from "../../../../contents/docs/getting-started/images/broken-down-trend-bar-light-mode.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  CreateNewActionLight,
  CreateNewActionDark,
  NamingTheActionLight,
  NamingTheActionDark,
  MatchGroupDark,
  MatchGroupLight,
  NewInsightDark,
  NewInsightLight,
  FilterReferrerAndBreakdownDark,
  FilterReferrerAndBreakdownLight,
  BrokenDownTrendBarDark,
  BrokenDownTrendBarLight,
  React
};